"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var twitter_1 = tslib_1.__importDefault(require("../../../social-buttons/twitter"));
var youtube_1 = tslib_1.__importDefault(require("../../../social-buttons/youtube"));
var facebook_1 = tslib_1.__importDefault(require("../../../social-buttons/facebook"));
var card_scss_1 = tslib_1.__importDefault(require("../../card.scss"));
var SocialCardContent = /** @class */ (function (_super) {
    tslib_1.__extends(SocialCardContent, _super);
    function SocialCardContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SocialCardContent.prototype.renderThumbnail = function () {
        var cardData = this.props.cardData;
        var thumbnailUrl = cardData.thumbnailUrl;
        if (!thumbnailUrl) {
            return null;
        }
        return (react_1.default.createElement("div", { className: card_scss_1.default.thumbnail },
            react_1.default.createElement("div", { className: card_scss_1.default.image, style: { backgroundImage: "url(".concat(thumbnailUrl, ")") } })));
    };
    SocialCardContent.prototype.renderText = function () {
        var cardData = this.props.cardData;
        var text = cardData.text;
        return (react_1.default.createElement("div", { className: card_scss_1.default.text },
            react_1.default.createElement("div", { className: card_scss_1.default['text-content'], "data-hook": "action-card-title" }, text)));
    };
    SocialCardContent.prototype.renderCta = function () {
        var cardData = this.props.cardData;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(card_scss_1.default.social, card_scss_1.default[cardData.network]), "data-hook": "action-card-action-text" }, this.renderSocialButton()));
    };
    SocialCardContent.prototype.renderSocialButton = function () {
        var _a = this.props, cardData = _a.cardData, labels = _a.labels, isAccessible = _a.isAccessible;
        var facebookButtonTitle = labels.facebookButtonTitle, youtubeButtonTitle = labels.youtubeButtonTitle, twitterButtonTitle = labels.twitterButtonTitle;
        switch (cardData.network) {
            case 'twitter':
                return (react_1.default.createElement(twitter_1.default, { isAccessible: isAccessible, twitterButtonTitle: twitterButtonTitle, cardData: cardData }));
            case 'youtube':
                return (react_1.default.createElement(youtube_1.default, { isAccessible: isAccessible, youtubeButtonTitle: youtubeButtonTitle, cardData: cardData }));
            case 'facebook':
                return (react_1.default.createElement(facebook_1.default, { isAccessible: isAccessible, facebookButtonTitle: facebookButtonTitle, cardData: cardData }));
            default:
                return null;
        }
    };
    SocialCardContent.prototype.render = function () {
        var _a = this.props, className = _a.className, isAriaHidden = _a.isAriaHidden;
        return (react_1.default.createElement("div", { className: className, "aria-hidden": isAriaHidden },
            this.renderThumbnail(),
            react_1.default.createElement("div", { className: card_scss_1.default.container },
                this.renderText(),
                this.renderCta())));
    };
    SocialCardContent.propTypes = {
        cardData: prop_types_1.default.object,
        className: prop_types_1.default.string,
        isAriaHidden: prop_types_1.default.bool,
        labels: prop_types_1.default.object,
        isAccessible: prop_types_1.default.bool,
    };
    return SocialCardContent;
}(react_1.default.Component));
exports.default = SocialCardContent;
//# sourceMappingURL=card-content.js.map